// extracted by mini-css-extract-plugin
module.exports = {"categoriesWrapper":"Categories_categoriesWrapper__C4uCI","title":"Categories_title__2O0VC","content":"Categories_content__3MskD"};